import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ResourceDetail from "../../components/manage-resources/resource-detail";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { Loader2 } from "lucide-react";

function ManageResourceDetail() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [resource, setResource] = useState(location.state?.resource || null);
  const [isLoading, setIsLoading] = useState(!location.state?.resource);

  useEffect(() => {
    if (location.state?.resource) {
      setResource(location.state.resource);
      setIsLoading(false);
      return;
    }
    if (!id) return;

    const fetchResource = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) { navigate("/"); return; }
      setIsLoading(true);
      try {
        const res = await fetch(`${BASE_URL}${API_ENDPOINTS.NONPROFIT_RESOURCES}/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const result = await res.json().catch(() => null);
        if (!res.ok) throw new Error(result?.message || "Failed to load resource.");
        setResource(result?.data || null);
      } catch (err) {
        toast.error(err.message || "Failed to load resource.");
        setResource(null);
      } finally {
        setIsLoading(false);
      }
    };
    fetchResource();
  }, [id, location.state, navigate]);

  if (isLoading) {
    return (
      <div className="w-[90%] lg:w-[95%] mx-auto mt-8 flex justify-center py-16">
        <Loader2 className="animate-spin text-[#3FC4E3]" size={32} />
      </div>
    );
  }

  return <ResourceDetail resource={resource} />;
}

export default ManageResourceDetail;
